import { createSelector } from '@reduxjs/toolkit'

import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'
import gameCategories from 'store/modules/games/categories.json'
import { geoBlockedGameCodesSelector } from 'store/modules/games/geoBlockedContentSelectors'
import { filterGeoBlockedGames } from 'store/modules/games/utils'
import { filterBingoGamesByMode } from 'utils/filterBingoGamesByMode'
import { hasTag } from 'utils/gameTags'

import type { ReduxState } from 'src/store/types'

const getPlayedGames = (state: ReduxState) => state.playedGames.games

export const getPlayedGamesLayout = (state: ReduxState) => state.playedGames.layout

export const playedGamesLoadedSelector = createSelector(
  (state: ReduxState) => state.playedGames,
  (playedGames) => playedGames.loaded,
)

// PLDV-8952 — geo-blocked games are filtered here at the data level so the
// existing NoPlayedGames empty state renders when nothing visible remains.
const visiblePlayedGamesSelector = createSelector(
  getPlayedGames,
  geoBlockedGameCodesSelector,
  (games, geoBlockedCodes) => (games ? filterGeoBlockedGames(games, geoBlockedCodes) : games),
)

export const playedSlotsSelector = createSelector(visiblePlayedGamesSelector, (games) => {
  return games?.filter((game) => {
    return gameCategories.slots.includes(game.type) && !hasTag(game.tags, 'table')
  })
})

export const playedTableGamesSelector = createSelector(visiblePlayedGamesSelector, (games) => {
  return games?.filter((game) => {
    return game.type !== 'lottery' && hasTag(game.tags, 'table')
  })
})

export const playedBingoGamesSelector = createSelector(
  visiblePlayedGamesSelector,
  getActiveCurrencyIdSelector,
  (games, activeCurrency) => {
    return filterBingoGamesByMode(games, activeCurrency, { onlyBingo: true })
  },
)

export const playedGamesLayoutSelector = createSelector(getPlayedGamesLayout, (layout) => layout)
